import { gql } from "@/__generated__/gql";

export const FUNNEL_CHART_DATA = gql(`
  query FunnelChartData(
    $date: Date!
    $orgId: ID!
    $filters: StudentListFilterInput!
  ) {
    node(id: $orgId) {
      ... on Organization {
        id
        funnelChartData(date: $date, filters: $filters) {
          inCommunity {
            state
            value
          }
          notInCommunity {
            state
            value
          }
        }
      }
    }
  }
`);
